import toNumber from "lodash/toNumber";

export const prepPrice = (v: string | number): number => {
  return toNumber((toNumber(v) * 100).toFixed(0));
};
